import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Table.module.scss";

/**
 * Table — clean rows separated by 1px lines, generous vertical padding.
 * Thin wrappers over native table elements so callers keep full control.
 * The wrapper scrolls horizontally so wide tables never break the layout.
 */
export function Table({ className, children, ...rest }) {
  return (
    <div className={styles.scroll}>
      <table className={cn(styles.table, className)} {...rest}>
        {children}
      </table>
    </div>
  );
}

Table.propTypes = { className: PropTypes.string, children: PropTypes.node };

export default Table;
